export default __webpack_public_path__ + "static/media/IMG_6687-1712875103500.62c3c222.PNG";